/**
 * Variant Media Handler
 * Ensures variant images are displayed when variants are selected
 * Works with media-gallery component to update featured images
 */

(function () {
  let allVariants = [];
  
  // Listen for DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantMediaHandler);
  } else {
    initVariantMediaHandler();
  }

  function initVariantMediaHandler() {
    // Get all variant data from the product
    loadVariantData();
    
    const mediaGallery = document.querySelector('media-gallery');
    const productInfo = document.querySelector('product-info');
    
    if (!mediaGallery || !productInfo) return;

    // Listen for variant changes via pubsub or direct events
    document.addEventListener('change', handleVariantSelectionChange);
  }

  function loadVariantData() {
    // Try to get variant data from various sources
    const variantSelects = document.querySelector('variant-selects');
    if (!variantSelects) return;

    const variantScript = variantSelects.querySelector('[data-selected-variant]');
    if (variantScript) {
      try {
        const selectedVariant = JSON.parse(variantScript.innerHTML);
        // We now have access to variant data through the product-info
      } catch (e) {
        console.warn('Could not parse variant data:', e);
      }
    }
  }

  function handleVariantSelectionChange(event) {
    const target = event.target;
    
    // Check if this is a variant selector input (swatch or dropdown)
    if (!target.matches('input[type="radio"], input[type="checkbox"], select')) return;
    
    // Check if it's in a variant form context
    const fieldset = target.closest('fieldset');
    const selectElement = target.closest('.product-form__input');
    
    if (!fieldset && !selectElement) return;
    
    // Wait a moment for product-info to update, then update media
    setTimeout(() => {
      updateMediaForSelectedVariant();
    }, 200);
  }

  function updateMediaForSelectedVariant() {
    const mediaGallery = document.querySelector('media-gallery');
    if (!mediaGallery) return;

    // Get the selected variant ID from the form
    const variantIdInput = document.querySelector('input[name="id"]');
    if (!variantIdInput || !variantIdInput.value) return;

    const variantId = variantIdInput.value;
    
    // Method 1: Try to find media by variant association
    const mediaItems = Array.from(mediaGallery.querySelectorAll('[data-media-id]'));
    
    // Try to match media to variant by looking for variant-specific images
    let foundMedia = null;
    
    for (let item of mediaItems) {
      const mediaId = item.getAttribute('data-media-id');
      
      // Check if the image in this media item matches variant
      const img = item.querySelector('img');
      if (img && img.alt) {
        // If alt text contains variant info, prioritize it
        if (img.alt.toLowerCase().includes('variant') || img.alt.toLowerCase().includes(variantId)) {
          foundMedia = item;
          break;
        }
      }
    }

    // If no variant-specific media found, use first media
    if (!foundMedia && mediaItems.length > 0) {
      foundMedia = mediaItems[0];
    }

    if (foundMedia) {
      const mediaId = foundMedia.getAttribute('data-media-id');
      
      // Use media-gallery's setActiveMedia method if available
      if (mediaGallery.setActiveMedia) {
        mediaGallery.setActiveMedia(mediaId, false);
      } else {
        // Fallback: manually set as active
        mediaItems.forEach(m => m.classList.remove('is-active'));
        foundMedia.classList.add('is-active');
        
        // Trigger slider update if needed
        const slider = mediaGallery.querySelector('[id^="GalleryViewer"]');
        if (slider && slider.slider) {
          slider.slider.scrollTo({ left: foundMedia.offsetLeft });
        }
      }
    }
  }

  // Listen to the pubsub variantChange event if available
  if (window.subscribe && window.PUB_SUB_EVENTS) {
    window.subscribe(window.PUB_SUB_EVENTS.variantChange, function(event) {
      if (event.data && event.data.variant && event.data.html) {
        // product-info has already updated the media, but ensure media-gallery is synced
        setTimeout(() => {
          const mediaGallery = document.querySelector('media-gallery');
          if (mediaGallery && event.data.variant.featured_media) {
            // Trigger media update with featured media ID
            const mediaId = event.data.variant.featured_media.id;
            
            // Look for the slide with this media ID
            const slide = mediaGallery.querySelector(`[data-media-id*="${mediaId}"]`);
            if (slide && mediaGallery.setActiveMedia) {
              mediaGallery.setActiveMedia(slide.getAttribute('data-media-id'), false);
            }
          }
        }, 50);
      }
    });
  }
})();
